import { MouseClickRightSvg } from "@lhd/assets";
import { COLUMN_TYPE_SETTING } from "@lhd/constants";
import { IData } from "./hook";

export const fieldsDefined = {
  name: "name",
  company_type: "company_type",
  show_company_type: "show_company_type",
  name_start_date: "name_start_date",
  status: "status",
  category: "category",
  co_number: "co_number",
  contract_start_date: "contract_start_date",
  industry_category_id: "industry_category_id",
  industry_category_apply_date: "industry_category_apply_date",
} as const;
export const useColumns = (size?: any) => {
  return [
    {
      columnId: "index",
      label: "",
      type: "text",
      width: 30,
      editable: false,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.name,
      label: "企業名（事業所名）",
      type: "text",
      width: 200,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.company_type,
      label: "企業形態",
      type: "text",
      width: 200,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.show_company_type,
      label: "前後",
      type: "text",
      width: 180,
      icon: <MouseClickRightSvg size={size} />,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.name_start_date,
      label: "企業名の開始日",
      type: "dateTimeCustom",
      width: 200,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.status,
      label: "取引ステータス",
      type: "text",
      width: 180,
      icon: <MouseClickRightSvg size={size} />,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.category,
      label: "契約種別",
      type: "text",
      width: 180,
      icon: <MouseClickRightSvg size={size} />,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.co_number,
      label: "取引先番号",
      type: "text",
      width: 180,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.contract_start_date,
      label: "契約種別の開始日",
      type: "dateTimeCustom",
      width: 200,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.industry_category_id,
      label: "事業の種類",
      type: "text",
      width: 200,
      icon: <MouseClickRightSvg size={size} />,
      resizable: true,
      reorderable: true,
    },
    {
      columnId: fieldsDefined.industry_category_apply_date,
      label: "業種選択の開始日",
      type: "monthPicker",
      width: 200,
      icon: <></>,
      resizable: true,
      reorderable: true,
    },
  ];
};

export const REQUIRED_FIELDS = [
  fieldsDefined.name,
  fieldsDefined.company_type,
  fieldsDefined.show_company_type,
  fieldsDefined.name_start_date,
  fieldsDefined.status,
  fieldsDefined.category,
  fieldsDefined.co_number,
  fieldsDefined.contract_start_date,
  fieldsDefined.industry_category_id,
  fieldsDefined.industry_category_apply_date,
];
export const FILTER_FIELDS: string[] = [
  fieldsDefined.name,
  fieldsDefined.company_type,
  fieldsDefined.show_company_type,
  fieldsDefined.name_start_date,
  fieldsDefined.status,
  fieldsDefined.category,
  fieldsDefined.co_number,
  fieldsDefined.contract_start_date,
  fieldsDefined.industry_category_id,
  fieldsDefined.industry_category_apply_date,
];
export const DATE_FIELDS = [
  fieldsDefined.name_start_date,
  fieldsDefined.contract_start_date,
  fieldsDefined.industry_category_apply_date,
];
export const columnTypeValueMap = Object.fromEntries(
  COLUMN_TYPE_SETTING.map((item) => [item.type, item.value]),
);
export const defaultInitialValues = {
  [fieldsDefined.name]: "",
  [fieldsDefined.company_type]: "",
  [fieldsDefined.show_company_type]: "",
  [fieldsDefined.name_start_date]: null,
  [fieldsDefined.status]: "",
  [fieldsDefined.category]: "",
  [fieldsDefined.co_number]: "",
  [fieldsDefined.contract_start_date]: null,
  [fieldsDefined.industry_category_id]: "",
  [fieldsDefined.industry_category_apply_date]: null,
};
export const ERROR_MESSAGES: { [key: string]: string } = {
  save_error: "保存に失敗しました。",
  save_success: "保存しました。",
  general: "必須項目を入力してください。",
  first_name: "姓を入力してください。",
  last_name: "名を入力してください。",
  name_start_date: "姓名の開始日を入力してください。",
  status: "取引状況を入力してください。",
  category: "契約種別を入力してください。",
  co_number: "取込先番号を入力してください。",
  show_company_type: "前後を入力してください。",
  contract_start_date: "契約種別の開始日を入力してください。",
  [fieldsDefined.industry_category_id]: "業種選択を入力してください。",
  [fieldsDefined.industry_category_apply_date]:
    "業種選択の開始日は来月以降に設定する必要があります。",
};

export const handleData = (data: IData[]) => {
  return [
    ...data,
    ...Array.from(Array(data.length > 100 ? 0 : 100 - data.length).keys()).map(
      (_) => ({
        ...defaultInitialValues,
      }),
    ),
  ];
};
export const checkInvalidValue = (value: any) => {
  if (value === null || value === undefined) {
    return true;
  }
  if (typeof value === "string" && !value.trim()) {
    return true;
  }
  if (typeof value === "number" && isNaN(value)) {
    return true;
  }
  if (value instanceof Date && isNaN(value.getTime())) {
    return true;
  }

  return false;
};

export const checkInvalid = (
  data: IData,
  fields?: string[],
  countFieldValidate?: number,
) => {
  let result = false;
  let haveData = false;
  let countFieldInvalid = 0;

  if (fields) {
    fields.forEach((fieldItem) => {
      const value = data?.[fieldItem as keyof IData];

      if (checkInvalidValue(value)) {
        result = true;
        countFieldInvalid = countFieldInvalid + 1;
      } else {
        haveData = true;
      }
    });
  } else {
    Object.keys(data).forEach((keyItem: string) => {
      const value = data?.[keyItem as keyof IData];

      if (checkInvalidValue(value)) {
        result = true;
      } else {
        haveData = true;
      }
    });
  }

  return {
    invalid:
      countFieldValidate === undefined
        ? result
        : result && fields && countFieldInvalid === countFieldValidate,
    haveData,
  };
};

export const reorderArray = (arr: any[], idxs: number[], to: number) => {
  const movedElements = arr.filter((_, idx) => idxs.includes(idx));
  const targetIdx =
    Math.min(...idxs) < to
      ? (to += 1)
      : (to -= idxs.filter((idx) => idx < to).length);
  const leftSide = arr.filter(
    (_, idx) => idx < targetIdx && !idxs.includes(idx),
  );
  const rightSide = arr.filter(
    (_, idx) => idx >= targetIdx && !idxs.includes(idx),
  );
  return [...leftSide, ...movedElements, ...rightSide];
};

export const CONTRACT_STATUS_OPTIONS = [
  {
    value: "prospect",
    label: "見込み客",
  },
  {
    value: "pre_contract",
    label: "契約前",
  },
  {
    value: "active",
    label: "契約中",
  },
  {
    value: "contracting",
    label: "取引中",
  },
  {
    value: "closed",
    label: "完了",
  },
  {
    value: "suspended",
    label: "停止中",
  },
];

export const CONTRACT_TYPE_OPTIONS = [
  {
    value: "customer",
    label: "顧客先",
  },
  {
    value: "supplier",
    label: "仕入先",
  },
  {
    value: "outsourcer",
    label: "外注先",
  },
  {
    value: "referrer",
    label: "紹介者",
  },
];
export const COMPANY_NAME_POSITION_OPTIONS = [
  {
    value: "before",
    label: "前",
  },
  {
    value: "after",
    label: "後",
  },
  {
    value: "no_display",
    label: "無",
  },
];

export const getFieldByLabel = (
  label: string | null,
  options: { value: string; label: string }[],
  isMultiple = false,
) => {
  if (!label) return;
  if (isMultiple) {
    const labels = label.split(",").map((item) => item.trim());
    return options
      ?.filter((i) => labels.includes(i?.label))
      .map((i) => i?.value);
  }
  return options?.find((i) => i?.label === label)?.value;
};

export const getFieldByValue = (
  value: string | null,
  options: { value: string; label: string }[],
  isMultiple = false,
) => {
  if (!value) return;
  if (isMultiple) {
    const values = value.split(",").map((item) => item.trim());
    return options
      ?.filter((i) => values.includes(i?.value))
      .map((i) => i?.label);
  }
  return options?.find((i) => i?.value === value)?.label;
};

export const titleModalEnums = {
  [fieldsDefined.show_company_type]: "前後",
  [fieldsDefined.status]: "取引ステータス",
  [fieldsDefined.category]: "契約種別",
  [fieldsDefined.industry_category_id]: "事業の種類",
};
export const optionModalEnums = {
  [fieldsDefined.show_company_type]: COMPANY_NAME_POSITION_OPTIONS,
  [fieldsDefined.status]: CONTRACT_STATUS_OPTIONS,
  [fieldsDefined.category]: CONTRACT_TYPE_OPTIONS,
};
